import { Collapse, Form, Input } from 'antd';
import { EmailListFormComponent } from './EmailListFormComponent';
import { validateUniversityName } from '../../Validators/ValidatorUniversity';
import { t } from 'i18next';
import type { ReactNode } from 'react';

export const UniversityFormComponent = (): ReactNode => {
  return (
    <>
      <Form.Item
        key="univeristyName"
        rules={[
          { required: true, message: t('validator.universityNameEmpty') },
          { validator: validateUniversityName },
        ]}
        name={['university', 'name']}
      >
        <Input required placeholder={t('uniForm.uniComp.name')} />
      </Form.Item>

      <Collapse
        items={[
          {
            key: 'universityRectors',
            label: t('uniForm.uniComp.rectors'),
            children: (
              <EmailListFormComponent
                buttonTitle={t('uniForm.uniComp.addRector')}
                propertyReference="rectors"
                parentReference={['university']}
                emailType={t('uniForm.uniComp.rectorEmailType')}
              />
            ),
          },
          {
            key: 'workplaceSafetySupervisors',
            label: t('uniForm.uniComp.workplaceSafetySupervisors'),
            children: (
              <EmailListFormComponent
                buttonTitle={t('uniForm.uniComp.addWorkplaceSafetySupervisor')}
                propertyReference="workplaceSafetySupervisors"
                parentReference={['university']}
                emailType={t(
                  'uniForm.uniComp.workplaceSafetySupervisorEmailType'
                )}
              />
            ),
          },
          {
            key: 'legalDepartmentMembers',
            label: t('uniForm.uniComp.legalDepartmentMembers'),
            children: (
              <EmailListFormComponent
                buttonTitle={t('uniForm.uniComp.addLegalDepartmentMember')}
                propertyReference="legalDepartmentMembers"
                parentReference={['university']}
                emailType={t('uniForm.uniComp.legalDepartmentMemberEmailType')}
              />
            ),
          },
        ]}
      />
    </>
  );
};
